const axios = require("axios");

export default axios.create({
  baseURL: "http://api.cityconnect.com.br/api/",
  timeout: 120000,
  headers: {
    "Content-Type": "aplication/json"
  }
});
